/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import TextElement from "../components/TextElement.jsx";
import BuildLogs from "../components/BuildLogs.jsx";

function BuildLogPage({buildId}) {

    return (
        <div className={"mt-4 space-y-4"}>
            <TextElement textType={"header-xl"}>
                Current Build: {buildId}
            </TextElement>

            <BuildLogs buildId={buildId}/>

        </div>
    );
}

BuildLogPage.propTypes = {};

BuildLogPage.defaultProps = {};


export default BuildLogPage;